import React, { useContext, useEffect } from 'react';
import { Loader, Texture } from 'pixi.js'
import { ease } from 'pixi-ease'
import { Sprite, Container, AnimatedSprite } from '@inlet/react-pixi'

import HomeContext from '../../../context/home-context';

let walkingTextures = []; // meed to declare here
let standByTextures = [];
let standBySadTextures = [];
let jumpingTextures = [];
let reverseWalkingTextures = [];
let eggTexture = '';

const Monster = () => {
    const loader = Loader.shared;
    const { homeContext } = useContext(HomeContext);
    const monsterSprite = React.useRef();

    switch (homeContext.monsterMenu.cluster) {
        case 'HSS':
            eggTexture = Texture.from("./assets/images/components/island/particle/eggs/SIT-egg-HSS.png");
            if (homeContext.monsterMenu.monsterLvl > 0) {
                for (let i = 0; i <= 48;) {

                    if (i >= 10) {
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_walking.json"].textures[`HSS_walking_000${i}.png`])
                    }
                    else {
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_walking.json"].textures[`HSS_walking_0000${i}.png`])
                    }

                    i += 3;
                }
                for (let i = 0; i <= 39;) {

                    if (i >= 10) {
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_standby.json"].textures[`HSS_stand by_000${i}.png`])
                    }
                    else {
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_standby.json"].textures[`HSS_stand by_0000${i}.png`])
                    }

                    i += 3;
                }
                for (let i = 0; i <= 48;) {

                    if (i >= 10) {
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_reverse_walking.json"].textures[`HSS_walking_000${i}.png`])
                    }
                    else {
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_reverse_walking.json"].textures[`HSS_walking_0000${i}.png`])
                    }

                    i += 3;
                }
                for (let i = 3; i <= 60;) {

                    if (i >= 10) {
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_jumping.json"].textures[`HSS_jumping up down_000${i}.png`])
                    }
                    else {
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_jumping.json"].textures[`HSS_jumping up down_0000${i}.png`])
                    }

                    i += 3;
                }
                for (let i = 24; i <= 96;) {
                    standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_sad.json"].textures[`HSS_sad_000${i}.png`])
                    i += 4;
                }
            }
            break;
        case 'DSB':
            eggTexture = Texture.from("./assets/images/components/island/particle/eggs/SIT-egg-DAB.png");
            if (homeContext.monsterMenu.monsterLvl > 0) {
                for (let i = 3; i <= 60;) {
                    if (i > 9)
                        standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_sad.json"].textures[`DSB_sketch_anim standby sad_000${i}.png`])
                    else
                        standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_sad.json"].textures[`DSB_sketch_anim standby sad_0000${i}.png`])
                    i += 3;
                }
                for (let i = 1; i <= 39;) {
                    if (i > 9)
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_jumping.json"].textures[`DSB_sketch_anim jump_000${i}.png`])
                    else
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_jumping.json"].textures[`DSB_sketch_anim jump_0000${i}.png`])
                    i += 2;
                }
                for (let i = 1; i <= 39;) {
                    if (i > 9)
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_walking.json"].textures[`DSB_sketch_anim walk_000${i}.png`])
                    else
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_walking.json"].textures[`DSB_sketch_anim walk_0000${i}.png`])
                    i += 2;
                }
                for (let i = 1; i <= 39;) {
                    if (i > 9)
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_reverse_walking.json"].textures[`DSB_sketch_anim walk_000${i}.png`])
                    else
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_reverse_walking.json"].textures[`DSB_sketch_anim walk_0000${i}.png`])
                    i += 2;
                }
                for (let i = 3; i <= 60;) {
                    if (i > 9)
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_standby.json"].textures[`DSB_sketch_anim standby_000${i}.png`])
                    else
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_standby.json"].textures[`DSB_sketch_anim standby_0000${i}.png`])
                    i += 3;
                }
            }
            break;
        case 'ICT':
            eggTexture = Texture.from("./assets/images/components/island/particle/eggs/SIT-egg-ICT.png");
            if (homeContext.monsterMenu.monsterLvl > 0) {
                for (let i = 0; i <= 38;) {
                    if (i >= 10) {
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_walking.json"].textures[`ICT_char_walk_000${i}.png`])
                    }
                    else {
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_walking.json"].textures[`ICT_char_walk_0000${i}.png`])
                    }
                    i += 2;
                }
                for (let i = 14; i <= 71;) {
                    standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_standby.json"].textures[`ICT_char_standby_000${i}.png`])
                    i += 3;
                }
                for (let i = 0; i <= 38;) {

                    if (i >= 10) {
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_reverse_walking.json"].textures[`ICT_char_walk_000${i}.png`])
                    }
                    else {
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_reverse_walking.json"].textures[`ICT_char_walk_0000${i}.png`])
                    }

                    i += 2;
                }
                for (let i = 2; i <= 40;) {

                    if (i >= 10) {
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_jumping.json"].textures[`ICT_char_jump_000${i}.png`])
                    }
                    else {
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_jumping.json"].textures[`ICT_char_jump_0000${i}.png`])
                    }

                    i += 2;
                }
                for (let i = 14; i <= 71;) {
                    standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_sad.json"].textures[`ICT_char_standby_sad_000${i}.png`])
                    i += 3;
                }
            }
            break;
        case 'CEFT':
            eggTexture = Texture.from("./assets/images/components/island/particle/eggs/SIT-egg-Food.png");
            if (homeContext.monsterMenu.monsterLvl > 0) {
                for (let i = 0; i <= 38;) {
                    if (i >= 10) {
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_walking.json"].textures[`CE&FS_green_walk_000${i}.png`])
                    }
                    else {
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_walking.json"].textures[`CE&FS_green_walk_0000${i}.png`])
                    }
                    i += 2;
                }
                for (let i = 0; i <= 57;) {
                    if (i >= 10) {
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_standby.json"].textures[`CE&FS_green_standby_000${i}.png`])
                    }
                    else {
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_standby.json"].textures[`CE&FS_green_standby_0000${i}.png`])
                    }
                    i += 3;
                }
                for (let i = 0; i <= 38;) {
                    if (i >= 10) {
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_reverse_walking.json"].textures[`CE&FS_green_walk_000${i}.png`])
                    }
                    else {
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_reverse_walking.json"].textures[`CE&FS_green_walk_0000${i}.png`])
                    }
                    i += 2;
                }
                for (let i = 1; i <= 39;) {
                    if (i >= 10) {
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_jumping.json"].textures[`CE&FS_green_jump_000${i}.png`])
                    }
                    else {
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_jumping.json"].textures[`CE&FS_green_jump_0000${i}.png`])
                    }
                    i += 2;
                }
                for (let i = 9; i <= 66;) {
                    if (i >= 10) {
                        standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_sad.json"].textures[`CE&FS_green_standby_sad_000${i}.png`])
                    }
                    else {
                        standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_sad.json"].textures[`CE&FS_green_standby_sad_0000${i}.png`])
                    }
                    i += 3;
                }
            }
            break;
        case 'ENG':
            eggTexture = Texture.from("./assets/images/components/island/particle/eggs/SIT-egg-Engineer.png");
            if (homeContext.monsterMenu.monsterLvl > 0) {
                for (let i = 10; i <= 67;) {
                    standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_sad.json"].textures[`Engine_blue_reverse_standby_sad_000${i}.png`])
                    i += 3;
                }
                for (let i = 1; i <= 39;) {
                    if (i > 9)
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_jumping.json"].textures[`Engine_blue_3_jump_000${i}.png`])
                    else
                        jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_jumping.json"].textures[`Engine_blue_3_jump_0000${i}.png`])
                    i += 2;
                }
                for (let i = 1; i <= 39;) {
                    if (i > 9)
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_walking.json"].textures[`Engine_blue_3_walk_000${i}.png`])
                    else
                        walkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_walking.json"].textures[`Engine_blue_3_walk_0000${i}.png`])
                    i += 2;
                }
                for (let i = 1; i <= 39;) {
                    if (i > 9)
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_reverse_walking.json"].textures[`Engine_blue_3_walk_000${i}.png`])
                    else
                        reverseWalkingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_reverse_walking.json"].textures[`Engine_blue_3_walk_0000${i}.png`])
                    i += 2;
                }
                for (let i = 3; i <= 60;) {
                    if (i > 9)
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_standby.json"].textures[`Engine_blue_3_standby_000${i}.png`])
                    else
                        standByTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_standby.json"].textures[`Engine_blue_3_standby_0000${i}.png`])
                    i += 3;
                }
            }
            break;
    }

    useEffect(() => {
        if (monsterSprite.current !== null && monsterSprite.current !== undefined) {
            homeContext.monsterMenu.moodMeter >= 50 ? jumpingInWest()
                : sadstandbyInEast()
        }
    }, [homeContext.monsterMenu.isMissing]);

    const goWalkingInWest = () => {
        if (monsterSprite.current !== null && monsterSprite.current !== undefined) {
            monsterSprite.current.textures = reverseWalkingTextures;
            monsterSprite.current.gotoAndPlay(0);
            const example1 = ease.target(monsterSprite.current, { x: 730, y: 350 }, 0.005, { repeat: false })
            example1.once('complete', () => {
                disappearInWest();
            })
        }
    }

    const goWalkingInEast = () => {
        if (monsterSprite.current !== null && monsterSprite.current !== undefined) {
            let x = Math.floor((Math.random() * 3) + 1);
            switch (x) {
                case 1:
                    monsterSprite.current.textures = jumpingTextures;
                    break;
                default:
                    monsterSprite.current.textures = walkingTextures;
                    break;
            }
            monsterSprite.current.gotoAndPlay(0);
            const example1 = ease.target(monsterSprite.current, { x: 1100, y: 380 }, 0.005, { repeat: false })
            example1.once('complete', () => {
                disappearInEast();
            })
        }
    }

    const standbyInEast = () => {
        if (monsterSprite.current !== null && monsterSprite.current !== undefined) {
            monsterSprite.current.x = 1200;
            monsterSprite.current.y = 300;
            monsterSprite.current.textures = standByTextures;
            monsterSprite.current.gotoAndPlay(0);
            appearInEast();
        }
    }

    const standbyInWest = () => {
        if (monsterSprite.current !== null && monsterSprite.current !== undefined) {
            monsterSprite.current.x = 660;
            monsterSprite.current.y = 310;
            monsterSprite.current.textures = standByTextures;
            monsterSprite.current.gotoAndPlay(0);
            appearInWest();
        }
    }

    const jumpingInEast = () => {
        if (monsterSprite.current !== null && monsterSprite.current !== undefined) {
            monsterSprite.current.x = 1200;
            monsterSprite.current.y = 300;
            monsterSprite.current.textures = jumpingTextures;
            monsterSprite.current.gotoAndPlay(0);
            appearInEast();
        }
    }

    const jumpingInWest = () => {
        if (monsterSprite.current !== null && monsterSprite.current !== undefined) {
            monsterSprite.current.x = 660;
            monsterSprite.current.y = 310;
            monsterSprite.current.textures = jumpingTextures;
            monsterSprite.current.gotoAndPlay(0);
            appearInWest();
        }
    }

    const appearInEast = () => {
        if (monsterSprite.current !== null && monsterSprite.current !== undefined) {
            const example1 = ease.add(monsterSprite.current, { alpha: 1 }, { repeat: false, duration: 4000 })
            example1.once('complete', () => {
                goWalkingInEast();
            })
        }
    }

    const appearInWest = () => {
        if (monsterSprite.current !== null && monsterSprite.current !== undefined) {
            const example1 = ease.add(monsterSprite.current, { alpha: 1 }, { repeat: false, duration: 4000 })
            example1.once('complete', () => {
                goWalkingInWest();
            })
        }
    }

    const disappearInEast = () => {
        if (monsterSprite.current !== null && monsterSprite.current !== undefined) {
            const example1 = ease.add(monsterSprite.current, { alpha: 0 }, { repeat: false, duration: 4000 })
            example1.once('complete', () => {

                if (monsterSprite.current !== null && monsterSprite.current !== undefined) {
                    monsterSprite.current.x = 660;
                    monsterSprite.current.y = 310;
                }
                let x = Math.floor((Math.random() * 3) + 1);
                switch (x) {
                    case 1:
                        jumpingInWest();
                        break;
                    default:
                        standbyInWest();
                        break;
                }
            })
        }
    }

    const disappearInWest = () => {
        if (monsterSprite.current !== null && monsterSprite.current !== undefined) {
            const example1 = ease.add(monsterSprite.current, { alpha: 0 }, { repeat: false, duration: 4000 })
            example1.once('complete', () => {

                if (monsterSprite.current !== null && monsterSprite.current !== undefined) {
                    monsterSprite.current.x = 1200;
                    monsterSprite.current.y = 300;
                }
                let x = Math.floor((Math.random() * 3) + 1);
                switch (x) {
                    case 1:
                        jumpingInEast();
                        break;
                    default:
                        standbyInEast();
                        break;
                }
            })
        }
    }

    const sadstandbyInEast = () => {
        if (monsterSprite.current !== null && monsterSprite.current !== undefined) {
            monsterSprite.current.x = 1200;
            monsterSprite.current.y = 300;
            monsterSprite.current.textures = standBySadTextures;
            monsterSprite.current.gotoAndPlay(0);
            ease.add(monsterSprite.current, { alpha: 1 }, { repeat: false, duration: 4000 })
        }
    }

    return (
        <>
            <Container x={10} y={90}>
                {
                    homeContext.monsterMenu.monsterLvl > 0 ?
                        !homeContext.monsterMenu.isMissing ?
                            <Container>
                                <AnimatedSprite ref={monsterSprite}
                                    alpha={1}
                                    isPlaying={true}
                                    initialFrame={0}
                                    textures={jumpingTextures}
                                    scale={{ x: 0.15, y: 0.15 }}
                                    animationSpeed={0.09}
                                />
                            </Container>
                            :
                            <></>
                        :
                        <Sprite
                            scale={{ x: 0.03, y: 0.03 }}
                            x={660} y={310} texture={eggTexture}
                        />
                }
            </Container>
        </>
    );
}

export { Monster as default }